import React from 'react';
import './Home.css';
import i from './img/2.png';
import im from './img/3.png';
import imm from './img/large-exclamation-mark.png';
import immm from './img/license.png';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';

export const Home = () => (
  <Container>

    <div style={styles.mainContainer}>

      <Fade bottom>

        {/* HERO */}
        <div style={styles.heroSection}>

          <h1 style={styles.heroTitle}>
            <span style={{ color: '#fff' }}>מקימים עסק</span>
            <img src={im} alt="2" style={styles.mainIcon} />
          </h1>

          <h1 style={styles.heroTitle}>
            <span style={{ color: '#fff' }}>מחדשים רישיון</span>
            <img src={im} alt="2" style={styles.mainIcon} />
            <img src={immm} alt="2" style={styles.mainIcon} />
          </h1>

          <h1 style={{ ...styles.heroTitle, color: '#fff' }}>
            <span>הגעתם למקום הנכון</span>
            <img src={imm} alt="2" style={styles.mainIcon} />
          </h1>

        </div>

        {/* SERVICES */}
        <div style={styles.servicesGrid}>

          {[
            "תכנון העסק",
            "התאמת העסק והדרכה בהתאם לצו רישוי עסקים",
            "אישור הרשויות המקומיות",
            "אישור משרד הבריאות",
            "היתר כסאות שולחנות חיצוני וסגירות חורף"
          ].map((text, index) => (
            <div key={index} style={styles.serviceCard}>

              <div style={styles.iconCircle}>
                <img src={i} alt="check" style={styles.checkIcon} />
              </div>

              <h3 style={styles.serviceText}>{text}</h3>

            </div>
          ))}

        </div>

      </Fade>

    </div>

  </Container>
);

const styles = {

  mainContainer: {
    direction: 'rtl',
    textAlign: 'center',
    padding: '70px 20px',
    fontFamily: 'Segoe UI, Tahoma, Geneva, sans-serif',
    minHeight: '100vh'
  },

  heroSection: {
    marginBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '22px'
  },

  heroTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    fontSize: '2.6rem',
    fontWeight: '800',
    color: '#ffffff',
    margin: 0,
    textShadow: '0 6px 20px rgba(0,0,0,0.3)'
  },

  mainIcon: {
    height: '52px',
    width: 'auto',
    objectFit: 'contain'
  },

  servicesGrid: {
    maxWidth: '820px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },

  serviceCard: {
    display: 'flex',
    alignItems: 'center',
    padding: '18px 22px',
    borderRadius: '16px',
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.15)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
    transition: 'all 0.3s ease',
    gap: '18px'
  },

  iconCircle: {
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },

  serviceText: {
    margin: 0,
    fontSize: '1.25rem',
    color: '#ffffff',
    fontWeight: '600',
    textAlign: 'right'
  },

  checkIcon: {
    width: '22px',
    height: '22px'
  }

};